<template>
    <div class="row">
        <div :class="(order.orderStatusId == 2 || order.orderStatusId == 1 && $store.state.role == 'warehouse') || ((order.orderStatusId == 5 || order.orderStatusId == 7) && ($store.state.role == 'branches' || $store.state.role == 'izbank-admin')) || ($store.state.role == 'admin' && order.orderStatusId == 4) ? 'col-md-9' : 'col-md-12'">
            <Loading v-if="showLoading" />
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات سفارش</div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0 order-table-details" v-if="order.domainData && Object.keys(order.domainData).length">
                            <tbody>
                                <tr>
                                    <td>نام شعبه:</td>
                                    <td>{{ order.domainData.title }}</td>
                                    <td>تاریخ سفارش:</td>
                                    <td>{{ new Date(order.datetime).toLocaleDateString('fa-IR') }}</td>
                                    <td>ساعت سفارش:</td>
                                    <td>{{ new Date(order.datetime).toLocaleTimeString('fa-IR') }}</td>
                                </tr>
                                <tr>
                                    <td>شماره سفارش:</td>
                                    <td>{{ order.themeOrderId }}</td>
                                    <td>وضعیت سفارش:</td>
                                    <td>{{ order.orderStatus.title }}</td>
                                    <td>تعداد:</td>
                                    <td>{{ order.totalCount }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">جزئیات سفارش</div>
                <div class="card-body">
                    <div class="card bg-gray-100 mb-3" v-for="(orderItem,index) in order.themeOrderItems" :key="index">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">
                                    <img :src="orderItem.theme.address ? ('https://cardapi.sabinarya.com' + orderItem.theme.address) : ('data:image/png;base64,' + orderItem.themeOrderItemMetaData[0].value2)" :alt="orderItem.theme.title" class="my-3 rounded-10">
                                </div>
                                <div class="col-md-9 pr-0 mt-3">
                                    <h5 class="theme-title mb-3"><b>{{ orderItem.theme.title }}</b></h5>
                                    <h5 class="theme-title mb-3">تعداد : <b>{{ orderItem.count }}</b></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3" v-if="(order.orderStatusId == 2 || order.orderStatusId == 1 && $store.state.role == 'warehouse') || ((order.orderStatusId == 5 || order.orderStatusId == 7) && ($store.state.role == 'branches' || $store.state.role == 'izbank-admin')) || ($store.state.role == 'admin' && order.orderStatusId == 4)">
            <div class="card">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">عملیات</div>
                <div class="card-body">
                    <button class="btn btn-success btn-block" v-if="($store.state.role == 'warehouse' || $store.state.role == 'admin') && order.orderStatusId != 2" @click="approveOrRejectOrder(2)">تایید سفارش</button>
                    <button class="btn btn-danger btn-block" v-if="($store.state.role == 'warehouse' || $store.state.role == 'admin') && order.orderStatusId != 2" @click="approveOrRejectOrder(3)">عدم تایید سفارش</button>
                    <button class="btn btn-primary btn-block" v-if="order.orderStatusId == 2 && ($store.state.role == 'warehouse' || $store.state.role == 'admin')" @click="approveOrRejectOrder(5)">ارسال شده</button>
                    <button class="btn btn-primary btn-block" v-if="(order.orderStatusId == 5 || order.orderStatusId == 7) && ($store.state.role == 'branches' || $store.state.role == 'izbank-admin')" @click="approveOrRejectOrder(6)">تحویل شده</button>
                    <button class="btn btn-danger btn-block" v-if="order.orderStatusId == 5 && ($store.state.role == 'branches' || $store.state.role == 'izbank-admin')" @click="approveOrRejectOrder(7)">تحویل نشده</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Single',
    data(){
        return {
            showLoading: true,
            order: {}
        }
    },
    methods: {
        getData(){
            this.$api.post('Themes/GetThemeOrderInfo',{themeOrderID: this.$route.params.id}).then(({data}) => {
                if(data.status){
                    let totalCount = 0;
                    data.result.themeOrderItems.map(item => totalCount += item.count);
                    this.order = data.result;
                    this.order.totalCount = totalCount;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        approveOrRejectOrder(orderStatus){
            this.showLoading = true;
            const postedData = {
                themeOrderID: this.$route.params.id,
                orderStatus
            };
            this.$api.post('Themes/ChangeStatusThemeOrder',postedData).then(({data}) => {
                if(data.status)
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.showLoading = true;
                        this.getData();
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>